import { Injectable } from '@angular/core';

export interface RuntimeConfig {
  SAML_CLIENT_ID: string;
  BASE_SAML_PROXY_URL: string;
  SPID_TEST_BUTTONS: boolean;
  AUTH_PROVIDER: 'legacy' | 'oidc' | 'oidc-client';
  /** OIDC authority base URL (used in 'oidc-client' mode). */
  OIDC_AUTHORITY: string;
  /** Backend callback URL registered on the OIDC authority (used in 'oidc-client' mode). */
  OIDC_TARGET_URL: string;
  /** SPID auth level requested (1, 2 or 3) (used in 'oidc-client' mode). */
  OIDC_LEVEL: 1 | 2 | 3;
  /** Max upload file size in MB. */
  FILE_SIZE_LIMIT: number;
}

const DEFAULTS: RuntimeConfig = {
  SAML_CLIENT_ID: '',
  BASE_SAML_PROXY_URL: '',
  SPID_TEST_BUTTONS: true,
  AUTH_PROVIDER: 'oidc',
  OIDC_AUTHORITY: 'https://auth.poliziadistato.it',
  OIDC_TARGET_URL: '',
  OIDC_LEVEL: 2,
  FILE_SIZE_LIMIT: 5,
};

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  private config: RuntimeConfig = DEFAULTS;

  async load(): Promise<void> {
    try {
      const configUrl = new URL('assets/config.json', document.baseURI).toString();
      const res = await fetch(configUrl);
      this.config = { ...DEFAULTS, ...(await res.json()) };
    } catch {
      console.warn('Failed to load runtime config, using defaults');
    }
  }

  get<K extends keyof RuntimeConfig>(key: K): RuntimeConfig[K] {
    return this.config[key];
  }
}

export function initializeRuntimeConfig(configService: RuntimeConfigService) {
  return () => configService.load();
}
